import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedOrderProvidersInput,
    PrintedOrderProviders,
    UpdatePrintedOrderProvidersInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedOrderProvidersService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPrintedOrderProviders(): Promise<PrintedOrderProviders[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedOrderProviders
                })
            ).data.listPrintedOrderProviders.items;
            if (data) return data as PrintedOrderProviders[];
        } catch (error) {
            console.error('Error finding PrintedOrderProviders:', error);
            return null;
        }
    }
    async printedOrdersByProvider(
        provider_id: string
    ): Promise<PrintedOrderProviders[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PrintedOrdersByProvider,
                    variables: {
                        provider_id
                    }
                })
            ).data.PrintedOrdersByProvider.items;
            if (data) return data as PrintedOrderProviders[];
        } catch (error) {
            console.error('Error finding PrintedOrderProviders:', error);
            return null;
        }
    }

    async createPrintedOrderProviders(
        input: CreatePrintedOrderProvidersInput
    ): Promise<PrintedOrderProviders> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedOrderProviders,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedOrderProviders;
            if (data) return data as PrintedOrderProviders;
        } catch (error) {
            console.error('Error creating PrintedOrderProviders:', error);
            return null;
        }
    }
    async updatePrintedOrderProviders(
        input: UpdatePrintedOrderProvidersInput
    ): Promise<PrintedOrderProviders> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedOrderProviders,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedOrderProviders;
            if (data) return data as PrintedOrderProviders;
        } catch (error) {
            console.error('Error creating PrintedOrderProviders:', error);
            return null;
        }
    }
}
